import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { Common } from 'src/_lib/interfaces/common.interface';
import { footers } from 'src/_lib/interfaces/footer.interface';
import { BrowserService } from 'src/_lib/service/browser.service';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  endpoint: string = environment.apiUrl;
  footerCache$?: Observable<Common<footers>> | null = null;
  footerDataUpdate: EventEmitter<footers> = new EventEmitter();

  constructor(private browser: BrowserService, private http: HttpClient) { }

  footerList(): Observable<Common<footers>> {
    if (this.footerCache$) {
      return this.footerCache$;
    }
    const storedFooter = this.getFooterFromStorage();
    if (storedFooter) {
      const wrapped: Common<footers> = {
        0: {
          success: true,
          data: storedFooter
        }
      } as any;
      this.footerCache$ = of(wrapped).pipe(shareReplay(1));
      return this.footerCache$;
    }
    this.footerCache$ = this.http
      .get<Common<footers>>(this.endpoint + 'footers/all-menus')
      .pipe(
        tap(res => {
          const footer = res?.[0]?.data;
          if (footer) {
            this.saveFooterToStorage(footer);
          }
        }),
        shareReplay(1)
      );
    return this.footerCache$;
  }

  saveFooterToStorage(data: footers): void {
    this.browser.localStorage?.setItem('footerData', JSON.stringify(data));
  }

  getFooterFromStorage(): footers | null {
    const data = this.browser.localStorage?.getItem('footerData');
    return data ? JSON.parse(data) : null;
  }

  earlyBirdUser(data: any) {
    return this.http.post(this.endpoint + '/api/v1/footers', data);
  }
}